import { GET_LIST_OF_CHILDREN } from "../../../enums/Request/request.types";

export const getListOfChildrenAction = (data) => {
    return {
        type: GET_LIST_OF_CHILDREN,
        payload: data,
    };
};
